import { useServerFn } from "@tanstack/react-start";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { getPostById } from "@/lib/blog.functions";
import { PostEditor } from "@/components/admin/PostEditor";

export const Route = createFileRoute("/_authenticated/admin/edit/$id")({
  component: EditPost,
});

function EditPost() {
  const { id } = Route.useParams();
  const fetchFn = useServerFn(getPostById);
  const [post, setPost] = useState<any | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    fetchFn({ data: { id } }).then(setPost).catch((e: Error) => setErr(e.message));
  }, [id, fetchFn]);

  if (err) return <p className="text-primary">{err}</p>;
  if (!post) return <p className="text-foreground/65">Loading…</p>;

  return (
    <div>
      <h1 className="headline-md mb-6">Edit post</h1>
      <PostEditor initial={post} />
    </div>
  );
}
